// extracted by mini-css-extract-plugin
module.exports = {"banner":"_496c260","expand":"_ed442ac"};